var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('div',[_c('welcome-no-community-component')],1):_c('div',[_c('b-spinner',{staticClass:"d-block mx-auto mt-3"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }